import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import type { Client, CreateClientData, UpdateClientData } from "../../types/client";
import clientService from "../services/client-service";

export const clientsQueryOptions = (params: Record<string, unknown> = {}) =>
	queryOptions({
		queryKey: ["clients", params],
		queryFn: () => clientService.list(params),
	});

export const clientQueryOptions = (id: string) =>
	queryOptions({
		queryKey: ["client", id],
		queryFn: () => clientService.findById(id),
	});

export const searchClientsQueryOptions = (searchTerm: string) =>
	queryOptions({
		queryKey: ["clients", "search", searchTerm],
		queryFn: () => clientService.search(searchTerm),
	});

export const useClientCreateMutation = () =>
	useMutation({
		mutationFn: (client: CreateClientData) => clientService.create(client),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["clients"],
			});
		},
	});

export const useClientUpdateMutation = (id: string) =>
	useMutation({
		mutationFn: (client: UpdateClientData) => clientService.updateById(id, client),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["clients"],
			});
			queryClient.invalidateQueries({
				queryKey: ["client", id],
			});
		},
	});

export const useClientDeleteMutation = () =>
	useMutation({
		mutationFn: (id: string) => clientService.deleteById(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["clients"],
			});
		},
	});
